import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  if (!window.location.pathname.startsWith('/nuevo-ticket')) {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith('/nuevo-ticket')) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Auth
export const loginApi            = (data) => api.post('/auth/login', data);
export const registroApi         = (data) => api.post('/auth/registro', data);
export const activarApi          = (id)   => api.put(`/auth/activar/${id}`);
export const usuariosApi         = ()     => api.get('/auth/usuarios');
export const pendientesApi       = ()     => api.get('/auth/pendientes');
export const miPerfilApi         = ()     => api.get('/auth/perfil');
export const actualizarPerfilApi = (data) => api.put('/auth/perfil', data);

// Clientes
export const clientesApi      = ()         => api.get('/clientes');
export const clienteApi       = (id)       => api.get(`/clientes/${id}`);
export const crearClienteApi  = (data)     => api.post('/clientes', data);
export const editarClienteApi = (id, data) => api.put(`/clientes/${id}`, data);
export const buscarClienteApi = (q)        => api.get(`/clientes/buscar?q=${q}`);

// Tickets
export const ticketsApi          = (params)   => api.get('/tickets', { params });
export const ticketApi           = (id)       => api.get(`/tickets/${id}`);
export const crearTicketApi      = (data)     => api.post('/tickets', data);
export const actualizarTicketApi = (id, data) => api.put(`/tickets/${id}`, data);
export const statsApi            = ()         => api.get('/tickets/stats');
export const descargarPDFApi     = (id)       => api.get(`/tickets/${id}/pdf`, { responseType: 'blob' });

// Implementaciones
export const implementacionesApi         = ()              => api.get('/implementaciones');
export const implementacionApi           = (id)            => api.get(`/implementaciones/${id}`);
export const crearImplementacionApi      = (data)          => api.post('/implementaciones', data);
export const actualizarImplementacionApi = (id, data)      => api.put(`/implementaciones/${id}`, data);
export const actualizarEtapaApi          = (id, etapaId, data) => api.put(`/implementaciones/${id}/etapas/${etapaId}`, data);

// Archivos
export const subirArchivoTicketApi   = (ticketId, formData) =>
  api.post(`/archivos/tickets/${ticketId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const listarArchivosTicketApi = (ticketId) => api.get(`/archivos/tickets/${ticketId}`);
export const subirArchivoImplApi     = (implId, formData) =>
  api.post(`/archivos/implementaciones/${implId}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const eliminarArchivoApi      = (filename) => api.delete(`/archivos/${filename}`);
export const urlArchivo              = (filename) => `/uploads/${filename}`;

// Reportes
export const reporteDatosApi = (params) => api.get('/reportes/datos', { params });
export const reportePDFApi   = (params) => api.get('/reportes/pdf', { params, responseType: 'blob' });

export default api;